import { Subscriber } from 'rxjs/Subscriber';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import {
  Component,
  ElementRef,
  forwardRef,
  NgModule,
  Input,
  Output,
  Directive,
  SimpleChange,
  SimpleChanges,
  OnChanges,
  ViewChild,
  ContentChild,
  AfterViewInit,
  ModuleWithProviders,
  AfterContentInit,
  Self,
  Optional,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  HostBinding,
  OnInit,
  OnDestroy
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import {
  FormControl,
  FormGroupDirective,
  NgControl, NgForm,
} from '@angular/forms';
import { ThemeModule, IsBoolean, toBoolean } from 'alyle-ui/core';
import { Subscription } from 'rxjs/Subscription';
import { LyInputContents } from './input-contents';
import { LyFieldDirective } from './ly-field.directive';
import {
  LyTheme,
  ThemeColor,
  themeProperty,
  LyStyleTheme
} from 'alyle-ui/core';

@Directive({
  selector: 'ly-default, ly-before, ly-after, ly-input ly-error, ly-input ly-hint'
})
export class LyInputCommon {}

@Directive({
  selector: 'ly-placeholder'
})
export class LyPlaceholder {}

@Directive({
  selector: 'ly-default'
})
export class LyDefault {}

@Directive({
  selector: 'ly-label'
})
export class LyLabel {}


@Component({
  selector: 'ly-text-field, ly-input, ly-textarea',
  styles: [":host { display: inline-block; position: relative; align-items: center; } :host /deep/ ly-before, :host /deep/ ly-after { display: inline-block; vertical-align: inherit; } :host /deep/ input, :host /deep/ textarea { border: none; outline: none; font-family: inherit; color: inherit; background: transparent; font-size: inherit; width: 100%; font-weight: 400; padding: 0; display: inline-flex; } :host.ly-hidden-input /deep/ .ly-input-container input, :host.ly-hidden-input /deep/ .ly-input-container textarea, :host.ly-default-off .ly-input-default { opacity: 0; } /** * Focus Input **/ :host.ly-focus-active .ly-input-underline:after { width: 100%; } :host.ly-focus-active .ly-input-top-label, :host.ly-focus-active /deep/ ly-top-label { font-size: 75%; top: 0; transform: translate(0, 0); } :host.ly-focus-active .ly-input-default { opacity: 0; } :host.ly-value-on .ly-input-placeholder { opacity: 0; } .ly-input-underline { position: absolute; bottom: 0.875em; height: 1px; right: 0; left: 0; } .ly-input-underline:after { content: ''; position: absolute; width: 0%; height: 2px; background: currentColor; left: 0; right: 0; margin: 0 auto; bottom: 0; transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms; } .ly-input-underline.ly-disabled { background: transparent; background-image: linear-gradient(to right, #b4b4b4 0%, #b4b4b4 33%, transparent 0%); background-size: 4px 1px; background-repeat: repeat-x; border-top: 0; background-position: 0; } .ly-input-underline.ly-disabled:after { width: 0%; } :host.ly-label-above .ly-input-float-label { font-size: 75%; top: 0; } /** * ly-label(placeholder) */ .ly-input-placeholder, .ly-input-default, .ly-input-float-label { pointer-events: none; position: absolute; bottom: 1.125em; top: 1.125em; margin: auto; font-size: 100%; transition: all 375ms cubic-bezier(0.23, 1, 0.32, 1); color: inherit; width: 100%; } .ly-input-content { width: 100%; position: relative; display: flex; } .ly-input-container { padding: 1.125em 0; position: relative; opacity: 1; display: inline-block; vertical-align: inherit; width: 100%; } .ly-input-container ::ng-deep input { text-align: inherit; } .bottom-field, .ly-error-container { position: absolute; bottom: 0; left: 0; width: 100%; pointer-events: none; font-size: 75%; transform: translate3d(0, calc(100% - 1.1em), 0); display: flex; } .bottom-field .bottom-field-space, .ly-error-container .bottom-field-space { flex: 1; } .ly-required { position: absolute; top: 1.125em; right: 0; pointer-events: none; transform: translate3d(0, 0, 0); opacity: 0.45; } :host.ly-input-invalid .ly-input-underline, :host.ly-input-invalid .ly-input-placeholder, :host.ly-input-invalid /deep/ ly-error, :host.ly-input-invalid .ly-input-float-label { color: #F44336 !important; } :host.ly-input-invalid .ly-input-underline:after { width: 100%; } .ly-input-content { color: currentColor; } "],
  template: "<ng-content select=\"ly-before\"></ng-content> <div class=\"ly-input-underline\" [color]=\"inputColor\" bg=\"input:underline\"></div> <div class=\"ly-input-container\"> <ng-content select=\"input, textarea\"></ng-content> <!-- ly-placeholder --> <ng-container *ngIf=\"placeholder; then isPlaceholderTemplate; else placeholderContainer\"></ng-container> <ng-template #isPlaceholderTemplate> <div *ngIf=\"toBoolean(placeholder) !== undefined && placeholderState\" color=\"input:label\" class=\"ly-input-placeholder\">{{ placeholder }}</div> </ng-template> <ng-template #placeholderContainer> <div *ngIf=\"lyPlaceholder !== undefined && placeholderState\" color=\"input:label\" class=\"ly-input-placeholder\"> <ng-content select=\"ly-placeholder\"></ng-content> </div> </ng-template> <!-- ly-default --> <ng-container *ngIf=\"toBoolean(default); then isDefaultTemplate\"></ng-container> <ng-template #isDefaultTemplate> <div *ngIf=\"!(lyDefault !== undefined) && defaultOff\" color=\"input:label\" class=\"ly-input-default\">Default: {{ default }}</div> <div *ngIf=\"lyDefault !== undefined && defaultOff\" color=\"input:label\" class=\"ly-input-default\"> <ng-content select=\"ly-default\"></ng-content>{{ default }} </div> </ng-template> <!-- ly-label --> <ng-container *ngIf=\"toBoolean(label); then _isLabelTemplate; else labelContainer\"></ng-container> <ng-template #_isLabelTemplate> <div *ngIf=\"label !== undefined\" color=\"input:label\" class=\"ly-input-float-label\">{{ label }}</div> </ng-template> <ng-template #labelContainer> <div *ngIf=\"lyLabel\" color=\"input:label\" class=\"ly-input-float-label\"> <ng-content select=\"ly-label\"></ng-content> </div> </ng-template> </div> <div class=\"ly-icon-required\" *ngIf=\"required\"></div> <div class=\"bottom-field\" *ngIf=\"!_isErrorState()\"> <ng-content select=\"ly-hint[align=start], ly-hint:not(ly-hint[align])\"></ng-content> <span class=\"bottom-field-space\"></span> <ng-content select=\"ly-hint[align=end]\"></ng-content> </div> <div class=\"bottom-field\" *ngIf=\"_isErrorState()\"> <ng-content select=\"ly-error\"></ng-content> </div> <ng-content select=\"ly-after\"></ng-content> ",
  // tslint:disable-next-line:use-host-property-decorator
  host: {
    '[class.ly-input-invalid]': '_isErrorState()',
    '[class.ng-untouched]': '_shouldForward("untouched")',
    '[class.ng-touched]': '_shouldForward("touched")',
    '[class.ng-pristine]': '_shouldForward("pristine")',
    '[class.ng-dirty]': '_shouldForward("dirty")',
    '[class.ng-valid]': '_shouldForward("valid")',
    '[class.ng-invalid]': '_shouldForward("invalid")',
    '[class.ng-pending]': '_shouldForward("pending")',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  preserveWhitespaces: false
})
export class LyInput implements OnInit, AfterContentInit, AfterViewInit, OnChanges, OnDestroy {
  _value: any;
  _elementType: 'input' | 'textarea';
  _color = 'primary';
  _inputColor = 'primary';
  currentValue: any;
  private paletteSubscription: Subscription;
  private changed = new Array<(value: any) => void>();
  private touched = new Array<() => void>();
  @ContentChild(LyFieldDirective) _field: LyFieldDirective;
  @ContentChild(LyPlaceholder) lyPlaceholder: LyPlaceholder;
  @ContentChild(LyDefault) lyDefault: LyDefault;
  @ContentChild(LyLabel) lyLabel: LyLabel;
  @Input() type = 'text';
  @Input() label: string;
  @Input() placeholder: string;
  @Input() @IsBoolean() labelAbove: boolean;
  @Input() default: string;
  _errorState: boolean;
  placeholderContainer: any;
  labelContainer: any;
  focusStateSuscription: Subscription;

  @HostBinding('class.ly-label-above')
  get isFloatingLabel(): boolean {
    return this.currentValueState || this.labelAbove || this.isDefault || this.focusState;
  }

  get placeholderState() {
    return !this.currentValueState && this.focusState || !this.currentValueState && !this.focusState && this.isFloatingLabel;
  }

  /**
   * inputColor
   */
  @Input('inputColor')
  set inputColor(val) {
    // this._color = val;
    if (val) {
      this._inputColor = val;
    }
  }
  get inputColor() {
    return this._inputColor;
  }
  @HostBinding('class.ly-focus-active') focusState: boolean;
  @HostBinding('class.ly-hidden-input')
  get defaultOff(): boolean {
    return this.currentValue === this.default && !this.focusState || !this.currentValueState && !this.focusState;
  }

  @Input() get disabled(): boolean { return this._field.disabled; }

  @Input() get required(): boolean { return this._field.required; }

  @HostBinding('class.ly-value-on')
  get currentValueState(): boolean {
    return (`${this.currentValue}`).length !== 0 && this.currentValue != null;
  }

  _valueBoolean(val) {
    return !(val === null || val === undefined || val === false || val === '');
  }

  _isErrorState(): boolean {
    if (this._field) {
      return this._field._ngControl.invalid && this._field._ngControl.touched || this._errorState;
    }
  }
  private updateError() {
    this._errorState = this._field._ngControl.invalid;
  }

  value() {
    return this.currentValue;
  }

  constructor(
    private theme: LyTheme,
    private styleTheme: LyStyleTheme,
    private _changeDetectorRef: ChangeDetectorRef
  ) {
    // this.paletteSubscription = this.theme.palette.subscribe((palette) => {
    //   this._inputColor = this.theme.colorOf(this._color);
    // });
  }
  toBoolean(val: any) {
    return toBoolean(val);
  }
  get isPlaceholder(): boolean {
    return toBoolean(this.placeholder) || !!this.lyPlaceholder;
  }
  get isDefault(): boolean {
    return toBoolean(this.default) || !!this.lyDefault;
  }
  get isLabel(): boolean {
    return toBoolean(this.label) || !!this.lyLabel;
  }

  ngOnInit() {
    // this._inputColor = this.theme.colorOf(this._color);
    this.focusStateSuscription = this._field.focusState.subscribe((fState: boolean) => {
      this.focusState = fState;
    });
    if (this._field._parent()) {
      this._field._parent().ngSubmit.subscribe((submit) => {
        this.updateError();
      });
    }
  }
  ngAfterViewInit() {
  }
  ngAfterContentInit() {
    if (this._field) {
      this.currentValue = this._field._ngControl.value;
      if (this._field._ngControl && this._field._ngControl.valueChanges) {
        this._field._ngControl.valueChanges.subscribe((val: any) => {
          this.currentValue = val;
          this._errorState = false;
          this._changeDetectorRef.markForCheck();
          /**
           * reset error of submit to false
           */
        });
      }
      this._field.focusState.subscribe((isFocused: boolean) => {
        if (this.isDefault) {
          if (!this.currentValueState) {
            this.currentValue = this.default;
            this._field._ngControl.valueAccessor.writeValue(this.default);
            this._field._ngControl.viewToModelUpdate(this.default);
          }
        }
        this._field.markForCheck();
        this._changeDetectorRef.markForCheck();
      });
    } else {
      console.warn('LyInput: Require input native');
    }
  }

  _shouldForward(prop: string): boolean {
    const control = this._field ? this._field._ngControl : null;
    return control && (control as any)[prop];
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.default) {
      if (this.isDefault && !this.currentValueState) {
        this.currentValue = this.default;
        this._field._ngControl.viewToModelUpdate(this.default);
      }
    }
  }
  ngOnDestroy() {
    this.focusStateSuscription.unsubscribe();
  }
}

@NgModule({
  imports: [CommonModule, FormsModule, ThemeModule],
  exports: [LyInput, LyInputContents, LyFieldDirective, LyInputCommon, LyDefault, LyLabel, LyPlaceholder],
  declarations: [LyInput, LyInputContents, LyFieldDirective, LyInputCommon, LyDefault, LyLabel, LyPlaceholder],
})
export class LyInputModule {}
